// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.demo-ruleForm[data-v-41a89a52] .el-form-item__error {\n  position: static !important;\n}\n", ""]);
// Exports
module.exports = exports;
